import axios from 'axios';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { confirmDialog } from 'primereact/confirmdialog';
import { Skeleton } from 'primereact/skeleton';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { CheckShowBtn, formatedDate } from '../../Helper/constent';
import { InputNumber } from 'primereact/inputnumber';

const ExpensesReport = () => {
    const { apiUrl, apiHeadersJson, store_id, user_role } = useContext(ConfigContext);
    const [rows, setRows] = useState([]);
    const [keyword, setKeyword] = useState(null);
    const [callApi, setCallApi] = useState(true);
    const [FilterExpenseDate, setFilterExpenseDate] = useState(null);
    const toast = useRef(null);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const { limit, order } = useParams();

    const [rowsPerPage, setRowsPerPage] = useState(limit || 10);
    const [sortOrder, setSortOrder] = useState(order, 'DESC');
    const navigate = useNavigate();
    const headers = apiHeadersJson;
    if (!limit || !order || !['ASC', 'DESC'].includes(order.toUpperCase())) {
        navigate('/ExpensesReports/30/DESC')
    }


    const GetList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Management/GetExpenseList`, { params: { store_id, limit, order, keyword, expense_date: FilterExpenseDate, }, headers });
            const { success, data, message } = response.data;
            setCallApi(false);
            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setDataTableLoading(false);
        }
    };


    useEffect(() => {
        if (store_id) { GetList(); }
    }, [store_id, limit, order]);

    useEffect(() => {
        if (callApi) { GetList(); }
    }, [callApi]);

    useEffect(() => {
        const timer = setTimeout(() => { keyword && GetList(); }, 1500);
        return () => clearTimeout(timer);
    }, [keyword]);

    const clearFilters = () => {
        setKeyword("");
        setFilterExpenseDate('');
        setCallApi(true)
    };
    const applyFilters = () => {
        GetList();
        setCallApi(true)
    };


    const paginatorLeft = <Button type="button" icon="pi pi-refresh" text onClick={GetList} />;

    const ActionBody = (data) => {
        const createdDate = new Date(data.created_date);
        const currentDate = new Date();
        const timeDifference = currentDate - createdDate;
        const within24Hours = timeDifference <= 24 * 60 * 60 * 1000;
        const isAdmin = user_role === 'admin';
        const edit = (within24Hours || isAdmin);

        return (
            edit && <>
                <Button outlined className='ms-3' size='small' icon="pi pi-trash" severity="danger" onClick={() => confirmDelete(data.expense_id)} />
            </>
        );
    };

    const confirmDelete = (id) => {
        confirmDialog({
            message: 'Are you sure you want to delete this Expense?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => DeleteBrand(id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const DeleteBrand = async (id) => {
        try {
            const response = await axios.delete(`${apiUrl}/Management/DeleteExpense`, { params: { expense_id: id }, headers });
            const { success, message } = response.data;
            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };


    return (
        <div className="container-fluid">
            <Toast ref={toast} />
            <div className="d-flex justify-content-between align-items-center mt-4">
                <div className="main-heading">
                    <h6>Expenses Report</h6>
                </div>
                <div className="main-heading-right">
                    <h6>Reports/Expenses Report</h6>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 mt-4">
                    <div className="card">
                        <div className="rounded-top px-3 py-2 bg-dark d-flex flex-wrap justify-content-between align-items-center">
                            <h4 className="text-white">Expenses Report</h4>
                        </div>
                        <div className='card-header'>
                            <div className="row">
                                <div className="col-md-4">
                                    <IconField iconPosition="left" className='w-100'>
                                        <InputIcon className="pi pi-search"> </InputIcon>
                                        <InputText
                                            onChange={(e) => setKeyword(e.target.value)}
                                            className='w-100'
                                            placeholder="Search By Name..."
                                        />
                                    </IconField>
                                </div>
                                <div className="col-md-4">
                                    <input
                                        type="date"
                                        value={FilterExpenseDate}
                                        className="form-control  h-100"
                                        onChange={(e) => setFilterExpenseDate(e.target.value)}
                                        required={true}
                                        placeholder='Enter Expense Amount'
                                    />
                                </div>
                                <div className="col-md-3">
                                    <Button label="Filter"
                                        disabled={!keyword && !FilterExpenseDate}
                                        icon="pi pi-filter" className="ms-3" onClick={applyFilters} />
                                    <Button
                                        disabled={!keyword && !FilterExpenseDate}
                                        label="Clear" icon="pi pi-times" severity='secondary' className="ms-3" onClick={clearFilters} />
                                </div>
                            </div>
                        </div>
                        {dataTableLoading ? (
                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
                                <Skeleton shape="rectangle" width="100%" height="40px" className="mb-1" />
                            ))
                        ) : (
                            <>
                                <div className="d-flex flex-wrap justify-content-between align-items-center">
                                    <div className="d-flex align-items-center p-3">
                                        <span className="me-2">Show:</span>
                                        <InputNumber
                                            value={rowsPerPage}
                                            onChange={(e) => setRowsPerPage(e.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    navigate(`/ExpensesReports/${rowsPerPage}/${sortOrder}`)
                                                }
                                            }}
                                            mode="decimal"
                                            showButtons
                                            min={1}
                                            step={10}
                                            className="me-3"
                                        />
                                        <span className="me-2">entries</span>
                                    </div>
                                    <div className="d-flex align-items-center p-3">
                                        <span className="me-2">Sort Order:</span>
                                        <select
                                            className="form-select"
                                            value={sortOrder}
                                            onChange={(e) => { setSortOrder(e.target.value); navigate(`/ExpensesReports/${rowsPerPage}/${e.target.value}`) }}
                                            style={{ width: '100px' }}
                                        >
                                            <option value="ASC">Ascending</option>
                                            <option value="DESC">Descending</option>
                                        </select>
                                    </div>
                                </div>
                                <DataTable
                                    value={rows}
                                    paginator
                                    rows={rowsPerPage}
                                    paginatorTemplate="CurrentPageReport PaginatorLeft"
                                    currentPageReportTemplate="Total Records: {totalRecords}"
                                    paginatorLeft={paginatorLeft}
                                    paginatorRight={<></>}
                                    sortOrder={sortOrder === 'ASC' ? 1 : -1}
                                >
                                    <Column field='expense_name' header='Expense Name' />
                                    <Column field='user_name' header='Entry By' />
                                    <Column body={(data) => formatedDate(data?.expense_date)} header='Expense Date' sortable />
                                    <Column field='expense_amount' header='Expense Amount' sortable />
                                    <Column field='expense_note' header='Expense Note' />
                                    <Column body={ActionBody} header='Action' />
                                </DataTable>
                            </>
                        )}
                    </div>
                    <div className="mb-5"></div>
                </div>
            </div>
        </div>
    );
};

export default ExpensesReport;
